import { useContext } from "react";
import TablaGrupo from "./TablaGrupo";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
interface ITablaCliente {
  listadoSeleccionado: any;
  setListadoSeleccionado: Function;
  localStorageSelect: string;
  localStorageFilter: string;
  formFilter: any; 
  listRefresh: Function; 
}

const TablaCliente = (props: ITablaCliente) => {
  const {
    listadoSeleccionado,
    setListadoSeleccionado,
    localStorageSelect,
    localStorageFilter,
    formFilter, 
    listRefresh,
  } = props;
  const { listaCandidatoSeleccionado } = useContext(SeleccionContext);

  return (
    <>
      {listaCandidatoSeleccionado &&
        listaCandidatoSeleccionado.map((item: any, key: number) => {
          const { clienteId, clienteNombre, grupos } = item;
          return (
            <>
              <div className="content-header-cliente" key={key}>
                <span className="title-header-table">
                  <p className="text-cliente">{clienteNombre}</p>
                </span>
              </div>
              <TablaGrupo
                list={grupos}
                clienteNombre={clienteNombre}
                listadoSeleccionado={listadoSeleccionado}
                setListadoSeleccionado={setListadoSeleccionado}
                localStorageSelect={localStorageSelect}
                localStorageFilter={localStorageFilter}
                formFilter={formFilter}
                listRefresh={listRefresh}
              />
            </>
          );
        })}
    </>
  );
};

export default TablaCliente;
